import { GateDefinitionEnum } from "@shared-features/enums";
import {DropdownModel} from "@shared/models/dropdown-model.model";
import {Expose} from "class-transformer";

export class GateDefinition extends DropdownModel {
  @Expose()
  public id?: number;
  @Expose()
  public type: GateDefinitionEnum;
  @Expose()
  public temperatureControl?: boolean;
  @Expose()
  public name: string;
  @Expose()
  public reference: string;
  @Expose()
  public truckClassify: string;

  @Expose()
  get dropDownDisplayName() {
    const infix = this.reference ? ` (${this.reference})` : '';
    return this.name + infix;
  }
  @Expose()
  get dropDownValue() {
    return this;
  }
}
